import { useEffect, useState, forwardRef } from "react";

import placeHolder from "../../../assets/images/Mon-delta_logo_page.webp";

const InstitutionItem = forwardRef(
  (
    {
      etablissement,
      selectedInstitution,
      setSelectedInstitution,
      filters,
      setMapScreen,
      filtersState,
      scrollbarRef,
      allEtablissements,
      filtersKeys,
    },
    ref
  ) => {
    const [isSelected, setIsSelected] = useState(false);

    //--- Get overlayScrollbar Instance from the parent component
    let scrollbarInstance = {};
    if (scrollbarRef.current) {
      scrollbarInstance = scrollbarRef.current.osInstance();
    }

    //--- Scroll the selected institution to the top
    const scrollTo = (etablissementArray, idToCompare, e) => {
      const i = etablissementArray.findIndex((elt) => elt.id === idToCompare);
      const { viewport } = scrollbarInstance.elements();
      viewport.scrollTo({
        top: e.currentTarget.offsetTop,
        behavior: "smooth",
      });
    };

    //--- Control if current item is active or not
    useEffect(() => {
      if (selectedInstitution) {
        if (selectedInstitution.id === etablissement.id) {
          setIsSelected(true);
          document.body.classList.add("no-scroll");
          // setMapScreen(true);
        } else {
          setIsSelected(false);
        }
      } else {
        setIsSelected(false);
      }
    }, [selectedInstitution]);

    //--- Trigger auto-scroll, set the selected item state
    const handleShowInstitution = (etablissement, e) => {
      scrollTo(allEtablissements, etablissement.id, e);
      setSelectedInstitution((prev) => {
        if (prev) {
          if (prev.id === etablissement.id) {
            return null;
          } else {
            return etablissement;
          }
        } else {
          return etablissement;
        }
      });
    };

    //--- Create a list of icons composed of the type of activity the entity has
    const iconList = [];
    // for (const category of etablissement[Object.keys(filters)[1]]) {
    //   for (const cat of filters[Object.keys(filters)[1]].values) {
    //     if (category === cat.slug) {
    //       iconList.push(cat.icon);
    //     }
    //   }
    // }

    //     let typeComponent = [];
    //     for (const element of etablissement[Object.keys(filters)[1]]) {
    //       for (const filter of filters[Object.keys(filters)[1]].values) {

    //         if (element === filter.slug) {
    //          {typeComponent.push(<span style={{marginRight:'5px'}}>{element}</span>)}
    //         }
    //       }
    //     }

    // const typeComponent = etablissement[Object.keys(filters)[1]].map((item, index) => {
    //   for (const filter of filters[Object.keys(filters)[1]].values) {
    //     if (item === filter.slug) {
    //       return (
    //         <span key={index} style={{ marginRight: "5px" }}>
    //           {item}
    //         </span>
    //       );
    //     }
    //   }
    // });

    let colorsArray = [];
    //--- Create Array of colors looping on first filter key
    // for (const element of etablissement[Object.keys(filters)[0]]) {
    //   for (const filter of filters[Object.keys(filters)[0]].values) {
    //     if (element === filter.slug) {
    //       colorsArray.push(filter.color);
    //     }
    //   }
    // }

    //--- Create the color bands depending on the colors Array created above
    // const colorBands = colorsArray.map((color, index) => {
    //   return (
    //     <span
    //       key={color + index}
    //       style={{ display: "inline-block", width: "50px", height: "5px", backgroundColor: `${color}` }}
    //     ></span>
    //   );
    // });
    // console.log(etablissement?.bien_ville, etablissement?.prestation_loyer_mensuel_cc)

   // TODO: Sécuriser
   const etablissementFilter = etablissement.filter?.[0]
   const etablissementGamme = etablissement.type_slug?.[0]
  const isMyterrain =  filtersState.type_slug ? filtersState.type_slug.includes("mon-terrain") : false
  const isAllFilter = filtersState.filter ? filtersState.filter.includes("all") || filtersState.filter.length === 0 : false
 


    return (
  
      <div
        className={`inst-item ${etablissement.type} ${etablissementFilter} ${etablissementGamme} ${isSelected ? "active " : ""} ${(isMyterrain || isAllFilter ) && "visible"}  `}
        key={etablissement.id}
        onClick={(e) => handleShowInstitution(etablissement, e)}
        ref={ref}
      >
        <div className="inst-item-wrapper">
          <div className="inst-item-header-wrapper">
            <img src={etablissement.url_icon} alt="" />
            <span>{etablissement.status}</span>
          </div>
          <div className="inst-item__img-wrapper">
            <img
              className={`${etablissement?.image !== null && etablissement?.image.includes('view.ricoh') ? "image-discreet" : ""}`}
              src={etablissement?.image !== null && etablissement?.image.includes('view.ricoh') ? `/wp-content/themes/glanum/assets/img/Mon-delta_logo_page.webp` : etablissement?.image}
              alt=""
              width="70"
              height="70"
            />
          </div>
          <div className="d-flex flex-column">
            {/* <div className="d-flex inst-item__color-band ">{colorBands}</div> */}
            {/* <div className="pb-2 pr-3"> */}
            <div className="inst-item__data-wrapper">
              <div
                className={`inst-item__label`}
              >
                {etablissement.label}
              </div>
              <div
                className={`inst-item__name`}
                dangerouslySetInnerHTML={{ __html: etablissement.name }}
              />
              <div className="inst-item__address">
                {etablissement.town}</div>
              <div className="inst-item-data-row">
                <div className="inst-item__type">{etablissement.housing_type}</div>inst-item 
                {
                  etablissement?.price && etablissement?.price.length !== 0 && etablissement.price !== "0 \u20ac" ?
                    (
                      <div className="inst-item__prix">
                        à partir de
                        <span>{etablissement.price}</span>
                      </div>
                    )
                    :
                    (
                      <div className="inst-item__prix">
                        Prix non renseigné
                      </div>
                    )
                }

              </div>
              <a className="btn-plus-info" href={`${etablissement.url}`}>Plus d'info</a>
              {/* <div className="inst-item__svg-list">{typeComponent}</div> */}

            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default InstitutionItem;
